<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-table #pt [value]="ownerStmtRezDetails" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="ownerStmtRezDetailId" selectionMode="single"
  [(selection)]="ownerStmtRezDetail" (onRowSelect)="onRowSelect($event)" [loading]="loading" [paginator]="showPagination" [rows]="25"
  [rowsPerPageOptions]="[25,100,200]" showCurrentPageReport="true"
  currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
  sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
  [resizableColumns]="true" [autoLayout]="true" [responsive]="true">

  <ng-template pTemplate="caption">
    <div class="d-block text-end justify-content-between align-items-center">
      <!-- <h1 style="float: left;margin: 6px;">Owner Stmt Rez Detail</h1> -->
      <span>
        <!--clear filters-->
        @if (showFilter) {
          <button pButton pRipple class="p-button-text"
            style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
          (click)="reloadPage()">Clear Filters</button>
        }

        <!--add new-->
        <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
        (click)="onOpenFormAdd()">New Owner Stmt Rez Detail+</button>
      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      @for (col of columns; track col) {
        <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
          {{col.header}}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      }
      <th [ngStyle]="{'width': 'auto'}"></th>
    </tr>
    @if (showFilter) {
      <tr>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'ownerStmtRezDetailId', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'title', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'description', 'in')"></th>
        <!-- <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'status', 'in')"></th> -->
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'quantity', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'amount', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'taxAmount', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'taxPct', 'in')"></th>
      </tr>
    }
  </ng-template>
  <ng-template pTemplate="body" let-ownerStmtRezDetail>
    @if (ownerStmtRezId && (ownerStmtRezId == ownerStmtRezDetail.ownerStmtRezId)) {
      <tr [pSelectableRow]="ownerStmtRezDetail">
        <td>{{ownerStmtRezDetail.ownerStmtRezDetailId}} </td>
        <td>{{ownerStmtRezDetail.title}}</td>
        <td>{{ownerStmtRezDetail.description}}</td>
        <!-- <td>{{ownerStmtRezDetail.status}}</td> -->
        <td>{{ownerStmtRezDetail.quantity}}</td>
        <td>{{ownerStmtRezDetail.amount}}</td>
        <td>{{ownerStmtRezDetail.taxAmount}}</td>
        <td>{{ownerStmtRezDetail.taxPct}}</td>
        <td><span style="float:none">
          <a>
            <i class="pi pi-pencil" aria-hidden="true"
            style="color:blue; font-size:110%; padding-right:20px;" (click)="onOpenFormEdit(ownerStmtRezDetail)"></i>
          </a>
        </span>
      </td>
    </tr>
  }
  @if (!ownerStmtRezId) {
    <tr [pSelectableRow]="ownerStmtRezDetail">
      <td>{{ownerStmtRezDetail.ownerStmtRezDetailId}} </td>
      <td>{{ownerStmtRezDetail.title}}</td>
      <td>{{ownerStmtRezDetail.description}}</td>
      <!-- <td>{{ownerStmtRezDetail.status}}</td> -->
      <td>{{ownerStmtRezDetail.quantity}}</td>
      <td>{{ownerStmtRezDetail.amount}}</td>
      <td>{{ownerStmtRezDetail.taxAmount}}</td>
      <td>{{ownerStmtRezDetail.taxPct}}</td>
      <td><span style="float:none">
        <a>
          <i class="pi pi-pencil" aria-hidden="true"
          style="color:blue; font-size:110%; padding-right:20px;" (click)="onOpenFormEdit(ownerStmtRezDetail)"></i>
        </a>
      </span>
    </td>
  </tr>
}
</ng-template>
</p-table>
